export class ReactionNotFoundError extends Error { }
